/* ==========================================================================
   EFFIMERO
   Vanilla JS. Kein Framework, keine Abhängigkeit, kein Build-Schritt.

   Alles ist progressive enhancement: ohne JavaScript funktionieren Navigation,
   Produktformular und Warenkorb weiterhin über normale Formulare und Links.

   Kein localStorage. Nichts überlebt den Reload — auch der Ton nicht.
   ========================================================================== */

(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var routes = document.documentElement.dataset;

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function money(cents) {
    var value = (cents / 100).toFixed(2);
    return (routes.moneyFormat || 'CHF {{amount}}').replace(/\{\{\s*amount\s*\}\}/, value);
  }

  /* --- Reveal ------------------------------------------------------------- */

  function initReveal() {
    // Die Bildmasken haengen am selben Beobachter wie der Text. Zwei Beobachter
    // fuer dieselbe Frage waeren zwei Antworten, die auseinanderlaufen koennen.
    var items = $$('.reveal, .media--image-reveal, .media--scale-in, [data-stagger]');
    if (!items.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

    items.forEach(function (el) { io.observe(el); });
  }

  /* --- Scroll-gebundene Effekte ------------------------------------------- */

  /* --- Lookbook ----------------------------------------------------------- */

  /* --- Header ------------------------------------------------------------- */

  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;

    if (header.classList.contains('header--over')) {
      var sentinel = document.createElement('div');
      sentinel.setAttribute('aria-hidden', 'true');
      header.parentNode.insertBefore(sentinel, header.nextSibling);

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          header.classList.toggle('is-stuck', !entries[0].isIntersecting);
        }, { rootMargin: '-80px 0px 0px 0px' }).observe(sentinel);
      }
    }

    var menu = $('[data-menu]');
    if (!menu) return;

    function setMenu(open) {
      menu.dataset.open = open ? 'true' : 'false';
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) { var first = $('a', menu); if (first) first.focus(); }
    }

    $$('[data-menu-open]').forEach(function (b) { on(b, 'click', function () { setMenu(true); }); });
    $$('[data-menu-close]').forEach(function (b) { on(b, 'click', function () { setMenu(false); }); });
    on(document, 'keydown', function (e) { if (e.key === 'Escape') setMenu(false); });
  }

  /* --- Cart --------------------------------------------------------------- */

  var Cart = {
    drawer: null,

    init: function () {
      Cart.drawer = $('[data-drawer]');
      if (!Cart.drawer) return;

      on($('[data-drawer-scrim]', Cart.drawer), 'click', function () { Cart.close(); });
      $$('[data-drawer-close]', Cart.drawer).forEach(function (b) {
        on(b, 'click', function () { Cart.close(); });
      });
      on(document, 'keydown', function (e) {
        if (e.key === 'Escape' && Cart.drawer.dataset.open === 'true') Cart.close();
      });

      $$('[data-cart-open]').forEach(function (b) {
        on(b, 'click', function (e) { e.preventDefault(); Cart.open(); });
      });

      Cart.bindBody();
    },

    open: function () {
      Cart.drawer.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
      var close = $('[data-drawer-close]', Cart.drawer);
      if (close) close.focus();
    },

    close: function () {
      Cart.drawer.dataset.open = 'false';
      document.body.style.overflow = '';
    },

    /* Delegiert, damit die Handler nach jedem Neuzeichnen weiter greifen. */
    bindBody: function () {
      on(Cart.drawer, 'click', function (event) {
        var button = event.target.closest('[data-qty]');
        if (!button) return;
        event.preventDefault();

        var row = button.closest('[data-line]');
        var input = $('input', row);
        var delta = parseInt(button.dataset.qty, 10);
        var next = Math.max(0, parseInt(input.value, 10) + delta);
        Cart.change(row.dataset.line, next);
      });

      on(Cart.drawer, 'change', function (event) {
        var input = event.target.closest('[data-line] input');
        if (!input) return;
        var row = input.closest('[data-line]');
        Cart.change(row.dataset.line, Math.max(0, parseInt(input.value, 10) || 0));
      });
    },

    request: function (url, body) {
      return fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Cart error');
          return data;
        });
      });
    },

    /*
       Das Stueck fliegt in die Tasche.

       Ein Klon des Produktbildes loest sich, schrumpft und wandert zum Zaehler
       im Header. Eine einzige Bewegung auf transform und opacity, danach raeumt
       sie sich selbst weg. Findet sie kein Bild oder keinen Zaehler, passiert
       gar nichts — die Bestaetigung haengt nie daran.
    */
    fly: function (form) {
      if (motionLevel() !== 'full') return;

      var scope = form.closest('.pdp, .product-hero, .section') || document;
      var source = $('.pdp__frame img, .product-hero img, .media img', scope);
      var target = $('[data-cart-open]');
      if (!source || !target || !source.getBoundingClientRect) return;

      var from = source.getBoundingClientRect();
      var to = target.getBoundingClientRect();
      if (!from.width || !to.width) return;

      var ghost = document.createElement('img');
      ghost.src = source.currentSrc || source.src;
      ghost.className = 'fly-ghost';
      ghost.style.left = from.left + 'px';
      ghost.style.top = from.top + 'px';
      ghost.style.width = from.width + 'px';
      ghost.style.height = from.height + 'px';
      document.body.appendChild(ghost);

      // Zielpunkt ist die Mitte des Zaehlers, der Massstab so klein, dass das
      // Bild dort als Punkt ankommt und nicht als Briefmarke.
      var dx = (to.left + to.width / 2) - (from.left + from.width / 2);
      var dy = (to.top + to.height / 2) - (from.top + from.height / 2);
      var scale = Math.max(0.06, 28 / Math.max(from.width, from.height));

      requestAnimationFrame(function () {
        ghost.style.transform = 'translate3d(' + dx + 'px,' + dy + 'px,0) scale(' + scale + ')';
        ghost.style.opacity = '0.15';
        ghost.style.borderRadius = '50%';
      });

      window.setTimeout(function () {
        if (ghost.parentNode) ghost.parentNode.removeChild(ghost);
      }, 1300);
    },

    add: function (form) {
      var data = new FormData(form);
      return Cart.addItems(
        [{ id: data.get('id'), quantity: parseInt(data.get('quantity') || '1', 10) }],
        {
          button: $('[type="submit"]', form),
          status: $('[data-form-status]', form),
          flyFrom: form
        }
      );
    },

    /*
       Der gemeinsame Weg in den Warenkorb. Das Kaufformular legt ein Stueck
       hinein, der Sammelknopf unter dem Vorschlag mehrere — Shopify nimmt in
       beiden Faellen dieselbe items-Liste, also gibt es hier auch nur einen
       Ablauf. Zwei getrennte Anfragen fuer zwei Stuecke wuerden den Drawer
       zweimal oeffnen und die Zaehleranimation uebereinanderlegen.

         items  [{ id, quantity }]
         opts   button, status, flyFrom
    */
    addItems: function (items, opts) {
      opts = opts || {};
      var button = opts.button;
      var status = opts.status;
      var label = button ? button.textContent.trim() : '';
      var first = items.length ? items[0].id : null;

      if (!items.length) return Promise.resolve();

      if (button) {
        button.disabled = true;
        button.classList.add('is-working');
      }
      if (status) { status.textContent = ''; }

      if (opts.flyFrom) Cart.fly(opts.flyFrom);

      return Cart.request((routes.cartAddUrl || '/cart/add') + '.js', { items: items })
        .then(function () { return Cart.refresh(first); })
        .then(function () {
          /*
             Die Bestaetigung laeuft in drei Schritten und in dieser Reihenfolge,
             weil sie sonst uebereinander liegt: der Knopf quittiert, der Zaehler
             hebt sich, und erst danach faehrt der Drawer ein. Wer sofort den
             Drawer aufreisst, nimmt dem Knopf seine Antwort weg.
          */
          if (button) {
            button.classList.remove('is-working');
            button.classList.add('is-added');
            button.textContent = button.dataset.labelAdded || 'Added';
          }

          window.setTimeout(function () { Cart.open(); }, 420);

          window.setTimeout(function () {
            if (!button) return;
            button.classList.remove('is-added');
            button.textContent = label || button.dataset.labelAdd || 'Add to bag';
          }, 1800);
        })
        .catch(function (err) {
          if (button) button.classList.remove('is-working');
          if (status) status.textContent = err.message;
        })
        .then(function () { if (button) button.disabled = false; });
    },

    change: function (key, quantity) {
      return Cart.request((routes.cartChangeUrl || '/cart/change') + '.js',
                          { id: key, quantity: quantity })
        .then(function () { return Cart.refresh(); })
        .catch(function () { window.location.href = routes.cartUrl || '/cart'; });
    },

    /*
       Der Drawer wird aus einer Section-Render-Anfrage neu gezeichnet statt im
       JS zusammengebaut. So bleibt die gesamte Darstellung in Liquid und es gibt
       keine zweite Wahrheit ueber das Aussehen einer Warenkorbzeile.
    */
    refresh: function (highlightVariant) {
      var url = (routes.cartUrl || '/cart') + '?section_id=cart-drawer';
      return fetch(url, { headers: { 'Accept': 'text/html' } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('[data-drawer-body]', doc);
          var head = $('[data-drawer-summary]', doc);
          var suggest = $('[data-drawer-suggest]', doc);
          var count = $('[data-cart-count]', doc);

          if (fresh) $('[data-drawer-body]', Cart.drawer).innerHTML = fresh.innerHTML;
          if (head) $('[data-drawer-summary]', Cart.drawer).innerHTML = head.innerHTML;

          // Die Empfehlung muss mitwandern. Blieb sie stehen, schlug sie nach dem
          // ersten Hinzufuegen genau das Stueck vor, das schon im Korb lag.
          var slot = $('[data-drawer-suggest]', Cart.drawer);
          if (slot && suggest) slot.innerHTML = suggest.innerHTML;

          var before = 0;
          var counter = $('[data-cart-count]');
          if (counter) before = parseInt((counter.textContent || '').replace(/\D/g, ''), 10) || 0;

          $$('[data-cart-count]').forEach(function (el) {
            if (count) el.textContent = count.textContent;
          });

          var after = 0;
          if (count) after = parseInt((count.textContent || '').replace(/\D/g, ''), 10) || 0;
          if (after > before) Cart.bumpCount();

          if (highlightVariant) Cart.highlight(highlightVariant);
        });
    },

    /*
       Die Ruecksicht. Der Zaehler im Header hebt sich kurz an, wenn er hochzaehlt.
       Keine Zahl, die springt, kein Punkt, der blinkt — eine kurze Bewegung, die
       sagt: angekommen.
    */
    bumpCount: function () {
      $$('[data-cart-count]').forEach(function (el) {
        el.classList.remove('is-bumped');
        // Reflow erzwingen, sonst startet die Animation beim zweiten Mal nicht neu
        void el.offsetWidth;
        el.classList.add('is-bumped');
      });
    },

    /*
       Die neue Zeile im Drawer bekommt einen einmaligen, ruhigen Durchlauf: erst
       die Flaeche, dann wieder weg. Damit sieht man, was gerade dazugekommen ist,
       auch wenn schon drei Zeilen dastehen.
    */
    highlight: function (variantId) {
      var row = $('[data-variant="' + variantId + '"]', Cart.drawer);
      if (!row) return;
      row.classList.add('is-new');
      window.setTimeout(function () { row.classList.remove('is-new'); }, 2200);
    }
  };

  /* --- Produktformular ---------------------------------------------------- */

  function initProductForms() {
    /* Das Attribut sitzt auf dem Wrapper; submit blubbert vom Formular hoch.
       Ohne fetch bleibt es beim normalen POST an /cart/add. */
    $$('[data-product-form]').forEach(function (wrapper) {
      on(wrapper, 'submit', function (event) {
        var form = event.target.closest('form');
        if (!form || !window.fetch) return;
        event.preventDefault();
        Cart.add(form);
      });
    });

    /*
       Variantenauswahl. Die Zuordnung Option -> Variante kommt als JSON aus
       Liquid, damit hier nichts ueber Titel geraten werden muss.
    */
    $$('[data-variants]').forEach(function (root) {
      var data;
      try { data = JSON.parse($('[data-variants-json]', root).textContent); }
      catch (e) { return; }

      var idField = $('[data-variant-id]', root);
      var priceEl = $('[data-variant-price]', root);
      var submit = $('[type="submit"]', root.closest('form') || root);

      function update() {
        var chosen = $$('input[type="radio"]:checked', root).map(function (i) { return i.value; });
        var match = data.find(function (v) {
          return v.options.length === chosen.length &&
                 v.options.every(function (o, i) { return o === chosen[i]; });
        });

        if (!match) return;
        if (idField) idField.value = match.id;
        if (priceEl) priceEl.textContent = money(match.price);
        if (submit) {
          submit.disabled = !match.available;
          submit.textContent = match.available
            ? (submit.dataset.labelAdd || 'Add to bag')
            : (submit.dataset.labelSoldOut || 'Sold out');
        }
      }

      $$('input[type="radio"]', root).forEach(function (input) { on(input, 'change', update); });
      update();
    });
  }

  /* --- Vorschlag unter dem Kaufknopf -------------------------------------- */

  /*
     Zwei Knoepfe, ein Ablauf. "In die Tasche" legt das vorgeschlagene Stueck
     hinein, "das Set" legt das aktuelle Stueck und alle Vorschlaege gemeinsam
     hinein — beide gehen durch Cart.addItems und damit durch dieselbe
     Bestaetigung wie das normale Kaufformular.

     Ohne gewaehlte Groesse passiert nichts ausser einem Hinweis. Die
     Alternative waere, die erste verfuegbare Groesse zu nehmen, und das ist
     keine Bequemlichkeit, sondern eine Ruecksendung.
  */
  function initCrossSell() {
    $$('[data-cross-sell]').forEach(function (root) {
      var status = $('[data-cross-status]', root);
      var items = $$('[data-cross-item]', root);

      function say(message) {
        if (status) status.textContent = message || '';
      }

      /* Liefert die gewaehlte Variante einer Zeile, oder null. Ein Stueck ohne
         Groessen traegt sie als verstecktes Feld, sonst steht sie im
         angekreuzten Radiobutton. */
      function variantOf(item) {
        var hidden = $('input[type="hidden"][data-cross-variant]', item);
        if (hidden) return hidden.value || null;
        var checked = $('input[type="radio"][data-cross-variant]:checked', item);
        return checked ? checked.value : null;
      }

      function nudge(item, button) {
        say(button.dataset.labelChoose || 'Choose a size');
        item.classList.add('is-asking');
        var firstBox = $('input[type="radio"]:not([disabled])', item);
        if (firstBox) firstBox.focus();
        window.setTimeout(function () { item.classList.remove('is-asking'); }, 1200);
      }

      items.forEach(function (item) {
        $$('input[data-cross-variant]', item).forEach(function (input) {
          on(input, 'change', function () { say(''); });
        });

        var button = $('[data-cross-add]', item);
        if (!button) return;

        on(button, 'click', function () {
          var id = variantOf(item);
          if (!id) { nudge(item, button); return; }
          say('');
          Cart.addItems([{ id: id, quantity: 1 }], {
            button: button,
            flyFrom: item
          });
        });
      });

      var setButton = $('[data-cross-add-set]', root);
      if (!setButton) return;

      on(setButton, 'click', function () {
        var payload = [];

        /* Das Stueck, auf dessen Seite wir stehen, kommt zuerst. Seine Variante
           haelt das Kaufformular bereits aktuell — dieselbe Zahl, die der
           normale Knopf verschicken wuerde. */
        var own = $('[data-product-form] [data-variant-id]');
        if (own && own.value) payload.push({ id: own.value, quantity: 1 });

        var missing = null;
        items.forEach(function (item) {
          var id = variantOf(item);
          if (!id) { if (!missing) missing = item; return; }
          payload.push({ id: id, quantity: 1 });
        });

        if (missing) { nudge(missing, setButton); return; }
        if (!payload.length) return;

        say('');
        Cart.addItems(payload, { button: setButton, flyFrom: root });
      });
    });
  }

  /* --- Hinweis nach unten -------------------------------------------------- */

  /* --- Sound -------------------------------------------------------------- */

  /*
     Ton startet nie von selbst und ueberlebt keinen Seitenwechsel. Kein
     localStorage, kein Autoplay, keine Ausnahme.
  */
  function initSound() {
    var toggle = $('[data-sound-toggle]');
    var audio = $('[data-sound]');
    if (!toggle || !audio) return;

    toggle.hidden = false;
    toggle.setAttribute('aria-pressed', 'false');

    on(toggle, 'click', function () {
      var playing = toggle.getAttribute('aria-pressed') === 'true';
      if (playing) {
        audio.pause();
        toggle.setAttribute('aria-pressed', 'false');
      } else {
        audio.volume = 0.35;
        audio.play().then(function () {
          toggle.setAttribute('aria-pressed', 'true');
        }).catch(function () {
          toggle.setAttribute('aria-pressed', 'false');
        });
      }
    });
  }

  /* --- Video -------------------------------------------------------------- */

  /* Auf Mobile wird das Video durch sein Standbild ersetzt — die Media-Query
     dafuer steht in der Section. Hier wird nur sichergestellt, dass ein Video,
     das nicht sichtbar ist, auch nicht dekodiert. */
  function initVideo() {
    var videos = $$('video[data-loop], video[data-autoplay-inview]');
    if (!videos.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var play = video.play();
          if (play && play.catch) play.catch(function () {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.15 });

    videos.forEach(function (v) { io.observe(v); });
  }

  /* --- Bewegungsstufe ----------------------------------------------------- */

  /*
     Drei Stufen, im Theme-Editor umschaltbar: aus, dezent, voll. Die Klasse
     sitzt am <html>, damit das CSS sie ohne Umweg erreicht. Wer reduzierte
     Bewegung eingestellt hat, landet immer auf "aus" — die Einstellung im
     Editor kann das nicht ueberstimmen.
  */
  function motionLevel() {
    var root = document.documentElement;
    if (reduced.matches) return 'off';
    if (root.classList.contains('motion-off')) return 'off';
    if (root.classList.contains('motion-subtle')) return 'subtle';
    return 'full';
  }

  /* --- Drift -------------------------------------------------------------- */

  /*
     Bilder wandern langsamer als die Seite durch ihren eigenen Rahmen. Alles
     laeuft in einem einzigen rAF-Loop und schreibt nur eine Custom Property —
     kein Layout, kein Reflow, nichts, was der Browser neu messen muss.

     Der Weg ist bewusst klein. Sichtbare Parallaxe ist ein Effekt; kaum
     sichtbare Parallaxe ist der Unterschied zwischen einer Seite, die lebt,
     und einer, die eine Bildergalerie ist.
  */
  function initDrift() {
    if (motionLevel() !== 'full') return;

    var items = $$('[data-drift]');
    if (!items.length) return;

    var ticking = false;
    var visible = [];

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var i = visible.indexOf(entry.target);
          if (entry.isIntersecting && i === -1) visible.push(entry.target);
          if (!entry.isIntersecting && i !== -1) visible.splice(i, 1);
        });
        request();
      }, { rootMargin: '120px 0px' });
      items.forEach(function (el) { io.observe(el); });
    } else {
      visible = items;
    }

    function frame() {
      ticking = false;
      var vh = window.innerHeight;

      visible.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var span = vh + rect.height;
        if (span <= 0) return;
        // -0.5 bis +0.5, waehrend das Element durchs Fenster laeuft
        var p = (vh - rect.top) / span - 0.5;
        var amount = parseFloat(el.dataset.drift || '0');
        el.style.setProperty('--drift-y', (p * amount * -0.6).toFixed(2) + 'px');
      });
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }

    on(window, 'scroll', request, { passive: true });
    on(window, 'resize', request);
    frame();
  }

  /* --- Zeilenweise Headline ----------------------------------------------- */

  /*
     Die Ueberschrift wird in Woerter zerlegt, die nacheinander ankommen. Der
     Versatz ist gedeckelt: bei einer langen Zeile soll das letzte Wort nicht
     eine Sekunde nach dem ersten eintreffen, sonst liest man beim Warten mit.
  */
  function initStagger() {
    if (motionLevel() === 'off') return;

    $$('[data-stagger]').forEach(function (el) {
      if (el.dataset.staggered === 'true') return;
      el.dataset.staggered = 'true';

      var words = el.textContent.trim().split(/\s+/);
      if (words.length < 2 || words.length > 24) return;

      el.textContent = '';
      words.forEach(function (word, i) {
        var span = document.createElement('span');
        span.className = 'stagger__word';
        span.textContent = word;
        span.style.transitionDelay = Math.min(i * 0.07, 0.55) + 's';
        el.appendChild(span);
        if (i < words.length - 1) el.appendChild(document.createTextNode(' '));
      });
    });
  }

  /* --- Header: aus- und einblenden ---------------------------------------- */

  /*
     Die Kopfzeile bleibt stehen.

     Vorher blendete sie beim Runterscrollen aus und beim Rauf wieder ein. Das
     spart Platz und kostet Orientierung: der Warenkorb und der Weg zurueck
     sind dann genau in dem Moment weg, in dem jemand sie sucht. Bei einem
     Laden mit einem einzigen Stueck ist die Kopfzeile ohnehin schmal.

     Die Funktion bleibt als Huelle stehen, damit der Aufruf weiter oben nicht
     ins Leere greift, und raeumt eine eventuell haengengebliebene Klasse weg.
  */
  function initHeaderScroll() {
    var header = $('[data-header]');
    if (header) header.classList.remove('is-hidden');
  }

  /* --- Karussell ---------------------------------------------------------- */

  /* --- Bildbetrachter ----------------------------------------------------- */

  /*
     Ein Klick auf ein Produktbild oeffnet es formatfuellend. Der Betrachter
     wird beim ersten Bedarf gebaut, nicht auf Vorrat, und haelt genau ein Bild
     — kein Karussell im Overlay, keine Miniaturen, kein Zaehler.
  */
  var viewer = null;

  function ensureViewer() {
    if (viewer) return viewer;
    viewer = document.createElement('div');
    viewer.className = 'viewer';
    viewer.setAttribute('data-open', 'false');
    viewer.innerHTML =
      '<button class="btn viewer__close" type="button" data-viewer-close>Close</button><img alt="">';
    document.body.appendChild(viewer);

    function close() {
      viewer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }

    on(viewer, 'click', function (e) {
      if (e.target.hasAttribute('data-viewer-close') || e.target === viewer) close();
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && viewer.getAttribute('data-open') === 'true') close();
    });

    return viewer;
  }

  /* --- Groessentabelle ---------------------------------------------------- */

  /*
     Faehrt von rechts ein wie der Warenkorb, weil es dieselbe Geste ist:
     etwas nachschlagen, ohne die Seite zu verlassen. Kein Modal in der Mitte,
     kein neuer Tab.
  */
  function initSizeGuide() {
    var guide = $('[data-guide]');
    if (!guide || guide.dataset.bound === 'true') return;
    guide.dataset.bound = 'true';

    function set(open) {
      guide.dataset.open = open ? 'true' : 'false';
      document.body.style.overflow = open ? 'hidden' : '';
      if (open) {
        var close = $('[data-guide-close]', guide);
        if (close) close.focus();
      }
    }

    $$('[data-guide-open]').forEach(function (b) { on(b, 'click', function () { set(true); }); });
    $$('[data-guide-close]', guide).forEach(function (b) { on(b, 'click', function () { set(false); }); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && guide.dataset.open === 'true') set(false);
    });
  }

  /* --- Sticky Kaufleiste, nur Mobil --------------------------------------- */

  /*
     Erscheint erst, wenn das Formular oben aus dem Bild gescrollt ist, und
     verschwindet wieder, sobald es zurueckkommt. Auf Desktop blendet das CSS
     sie ganz aus — eine dauerhafte Kaufleiste am grossen Bildschirm ist die
     Aesthetik, die hier nicht vorkommt.
  */
  function initBuyBar() {
    var bar = $('[data-buy-bar]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    if (bar.dataset.bound === 'true') return;
    bar.dataset.bound = 'true';

    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-in', !entries[0].isIntersecting);
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(anchor);
  }

  /* --- Der Zeiger ueber Bildern ------------------------------------------- */

  /* --- Magnetische Knoepfe ------------------------------------------------ */

  /* --- Fortschritt beim Scrollen ------------------------------------------ */

  /*
     Eine Haarlinie am oberen Rand, die mitwaechst. Kein Prozentwert, keine
     Zahl — nur das Gefuehl, zu wissen, wo man ist. Sie liegt im Header, also
     verschwindet sie mit ihm, wenn man nach unten scrollt.
  */
  function initProgress() {
    if (motionLevel() === 'off') return;

    var header = $('[data-header]');
    if (!header || header.dataset.progressBound === 'true') return;
    header.dataset.progressBound = 'true';

    var bar = document.createElement('span');
    bar.className = 'progress';
    bar.setAttribute('aria-hidden', 'true');
    header.appendChild(bar);

    var ticking = false;

    function frame() {
      ticking = false;
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? window.pageYOffset / max : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
    }

    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(frame);
    }, { passive: true });

    on(window, 'resize', frame);
    frame();
  }

  /* --- Sofortsuche -------------------------------------------------------- */

  /*
     Ab zwei Zeichen wird gefragt, mit 220 ms Ruhe dazwischen — schnell genug,
     dass es sich sofort anfuehlt, langsam genug, dass nicht jeder Tastendruck
     eine Anfrage ausloest. Eine laufende Anfrage wird abgebrochen, sobald die
     naechste startet; sonst ueberholt eine alte Antwort die neue.

     Die Darstellung kommt aus Liquid, nicht von hier. Das Skript holt Markup
     und haengt es ein, mehr nicht.
  */
  function initPredictiveSearch() {
    var panel = $('[data-search-panel]');
    if (!panel || panel.dataset.bound === 'true') return;
    panel.dataset.bound = 'true';

    var form = $('[data-predictive-form]', panel);
    var input = $('[data-predictive-input]', panel);
    var results = $('[data-predictive-results]', panel);
    if (!form || !input || !results) return;

    var timer = null;
    var controller = null;

    function open() {
      panel.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
      window.setTimeout(function () { input.focus(); }, 60);
    }

    function close() {
      panel.dataset.open = 'false';
      document.body.style.overflow = '';
      results.innerHTML = '';
      input.value = '';
    }

    $$('[data-search-open]').forEach(function (b) { on(b, 'click', open); });
    $$('[data-search-close]', panel).forEach(function (b) { on(b, 'click', close); });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && panel.dataset.open === 'true') close();
    });

    function query(term) {
      if (!window.fetch) return;
      if (controller && controller.abort) controller.abort();
      controller = ('AbortController' in window) ? new AbortController() : null;

      var url = form.dataset.url + '?q=' + encodeURIComponent(term) +
                '&resources[type]=product&resources[limit]=6' +
                '&section_id=predictive-search-results';

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('.shopify-section', doc) || doc.body;
          results.innerHTML = fresh.innerHTML;
        })
        .catch(function () {});
    }

    on(input, 'input', function () {
      var term = input.value.trim();
      window.clearTimeout(timer);

      if (term.length < 2) {
        results.innerHTML = '';
        return;
      }

      timer = window.setTimeout(function () { query(term); }, 220);
    });
  }

  /* --- Empfehlungen ------------------------------------------------------- */

  /* --- Club: die Karte kippen --------------------------------------------- */

  /* --- Club: der Willkommensgruss ----------------------------------------- */

  /* --- Start -------------------------------------------------------------- */

  function init() {
    initStagger();
    initReveal();
    initDrift();
    initHeader();
    initHeaderScroll();
    initBuyBar();
    initSizeGuide();
    initProgress();
    initPredictiveSearch();
    Cart.init();
    initProductForms();
    initCrossSell();
    initSound();
    initVideo();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Der Theme-Editor haengt Sections neu ein, ohne die Seite zu laden. */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
